export default Object.freeze([
  {
    label: 'v64.0',
    value: '64.0',
  },
  {
    label: 'v63.0',
    value: '63.0',
  },
  {
    label: 'v62.0',
    value: '62.0',
  },
  {
    label: 'v61.0',
    value: '61.0',
  },
  {
    label: 'v60.0',
    value: '60.0',
  },
  {
    label: 'v59.0',
    value: '59.0',
  },
  {
    label: 'v58.0',
    value: '58.0',
  },
  {
    label: 'v57.0',
    value: '57.0',
  },
  {
    label: 'v56.0',
    value: '56.0',
  },
  {
    label: 'v55.0',
    value: '55.0',
  },
  {
    label: 'v54.0',
    value: '54.0',
  },
]);
